import { useEffect, useState } from 'react';
import { Typography } from 'antd';
import { useGetManyTransports } from 'api/transports/use-get-many-transports';
import { useTransportFiltersStore } from 'shared/stores/use-transport-filters';
import { SearchFilter } from 'components/common/search-filter';
import styles from './transport-search.module.scss';

export const TransportSearch = () => {
  const [searchString, setSearchString] = useState('');
  const { setSearch } = useTransportFiltersStore();

  const { data: transports, isError } = useGetManyTransports({
    limit: 10,
    isHints: true,
    search: searchString,
    isSkip: !searchString,
    withNotUsed: true,
  });

  const [options, setOptions] = useState<{ value: string; label: React.ReactNode }[]>([]);

  useEffect(() => {
    if (transports && !isError) {
      const values = transports.data.map((transport) => ({
        label: (
          <>
            <Typography.Text strong>{transport.plateNumber}</Typography.Text>{' '}
            <Typography.Text className={styles.hintSecondaryInfo}> {transport.type}</Typography.Text>
            <Typography.Text className={styles.hintSecondaryInfo}> / {transport.subType}</Typography.Text>
          </>
        ),
        value: transport.plateNumber,
      }));
      setOptions(values);
    } else {
      setOptions([]);
    }
  }, [transports, isError]);

  const selectHandler = (value: string) => {
    setSearch(value);
  };

  return (
    <SearchFilter
      options={options}
      setSearch={setSearch}
      setSearchString={setSearchString}
      selectHandler={selectHandler}
    />
  );
};
